import { Stack } from '@mui/material';
import HoursAlert from '../../hours-alert/hours-alert.component';
import NormalHoursCalendar from 'components/location-hours/normal-hours-calendar/normal-hours-calendar.component';

const NormalHours = () => {
  return (
    <Stack direction="column" gap={2} mt={2}>
      <HoursAlert />
      <NormalHoursCalendar />
    </Stack>
  );
};

export default NormalHours;
